"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { HomeV2Navbar } from "@/components/homev2/navbar";

export default function HomeV2Layout({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const hideNavbar = pathname.startsWith("/v2/login");

  return (
    <div className="flex min-h-screen flex-col bg-white">
      {hideNavbar ? null : <HomeV2Navbar />}
      <main className="flex-1">{children}</main>
    </div>
  );
}
